<template>
    <li class="dropdown notifications" role="menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                <i class="icon icon-bell-o"></i>
            </a>
            <span class="counter" v-show="unread >= 1">{{ unread }}</span>

            <div class="dropdown-menu alert-dropdown" role="dialog">
                <div class="header">
                    <a class="pull-right" v-on:click.stop="readAll">Mark all Read</a>

                    <h3>Notifications</h3>
                    <button id="noticeReload" class="hide" v-on:click.prevent="fetch"></button>
                    <button id="noticeUpdate" class="hide" v-on:click.prevent="update"></button>
                </div>
                <ul class="notification-list media-list">
                    <li class="media" :id="'notice-id-' + item.id" v-for="(item, index) in list" :data-index="index">
                        <div class="media-left">
                            <i class="icon" :class="{ 'icon-circle-o' : item.read, 'icon-circle' : !item.read }"
                               v-on:click.stop="read(item)"></i>
                        </div>

                        <div class="media-body">
                            <h5 class="media-heading">{{ item.title }}</h5>
                            <a class="dismiss" v-on:click.stop="del(item)">
                                <i class="icon icon-close"></i>
                            </a>
                            <!--<a href="">Edit Website</a>-->

                            <p class="small text-muted">
                                <!--<i class="icon icon-clock-o"></i>-->
                                <span class="time"> {{ item.time }}</span>
                            </p>

                        </div>
                    </li>
                    <li style="display: none;">
                        <a href="/get-activity" data-toggle="modal" data-target="#boldModal"><i
                                class="icon icon-list"></i>Show all</a>
                    </li>
                </ul>
            </div>
        </li>
</template>

<script>
export default {
    data: function () {
        return {
            list: [],
            latest: false,
            unread: 0,
            timeout: false
        };
    },

    created() {
        this.fetch();
        this.$eventHub.$on('newNotif', this.update);
    },

    methods : {
        fetch: function () {
            this.axios.get('/notification/list').then(function (response) {
                if (response.data) {
                    this.list = response.data;
                    this.countRead();
                    // TODO : Improve
                    let vm = this;
                    $.each(this.list, function (key, item) {
                       if (item.status === 2) {
                           item.timeout = true;
                           vm.$eventHub.$emit('latest-notif', item);
                       }
                    });
                }
            }.bind(this));
        },
        update: function (item) {
            item.timeout = true;
            this.$eventHub.$emit('latest-notif', item);
            this.list.push(item);
        },
        countRead: function () {
            let unread = 0;
            $.each(this.list, function (index, value) {
                if (value.read) return;
                unread++;
            });
            this.unread = unread;
        },

        hideUpdate: function () {
            $('#websiteNotification .nt-title').show();
            this.latest = false;
        },

        read: function (item) {
            item.read = !item.read;
            this.axios.get('/notification/read/' + item.id).then(function (response) {
                /*if (response.data) {
                 this.list.$set(item.id, response.data);
                 }*/
            }.bind(this));
            this.countRead();
        },

        readAll: function () {
            this.axios.get('/notification/read/all').then(function (response) {
                this.fetch();
            }.bind(this));
            this.unread = 0;
        },

        del: function (item) {
            this.axios.get('/notification/delete/' + item.id).then(function (response) {
                let index = this.list.indexOf(item);
                this.list.splice(index, 1);
            }.bind(this));
        }
    }
}
</script>
